<template>
  <el-upload
             :file-list="fileList"
             :on-remove="handleRemove"
             :http-request="uploading"
             :limit="1"
             :headers="headers"
             :data="data"
             list-type="picture-card"
             :show-file-list="true"
             :auto-upload="true">
             <el-button>点击上传</el-button>

  </el-upload>
</template>

<script setup>
import { base_img } from '../../api/config'
import OSS from "ali-oss"
import {ref, toRefs, watch} from "vue";
import {useStore} from "vuex";
const store = useStore()
const disabled = ref(false)
const imageUrl = ref("")
const headers = {token:store.getters.token};
const data = {uploadType:"banner",durable:1};
const fileList = ref([])
let credentials = null; // STS凭证
let ossClient = null; // oss客户端实例
let credentialPromise = null; // 凭证获取的 Promise，用于确保只获取一次
const bucket = 'birdseye'; // bucket名称
const region = 'oss-cn-guangzhou'; // oss服务区域名称

const props = defineProps({
  url: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: new Date().getTime(),
  },
  filename: {
    type: String,
    default: new Date().getTime(),
  }
});

// 监听 url 变化，更新 fileList
watch(() => props.url, (newUrl) => {
  if (newUrl) {
    // 如果 fileList 为空或当前项不存在，则添加
    if (fileList.value.length === 0) {
      fileList.value.push({name: props.name, url: newUrl});
    } else {
      // 如果已有项，更新第一项的 url
      fileList.value[0] = {name: props.name, url: newUrl};
    }
  } else {
    // 如果 url 为空，清空 fileList
    fileList.value = [];
  }
}, { immediate: true });


function getFileName(url) {
  return  new Date().getTime() + url.substring(url.lastIndexOf("."))
}

let transToFile = async(blob, fileName, fileType) => {
  let file = new File([blob], fileName, {type: fileType, lastModified: Date.now()});
  fileList.value.push(file)
}

const emit = defineEmits(["uploadSuccess","handleRemove"]);

const handleRemove = (file) => {
  fileList.value = [];
  emit("handleRemove", false, props.name);
}

async function uploading(option){
  try {
    // 确保凭证已获取并初始化 OSS 客户端
    if (!ossClient || !credentials) {
      await ensureOSSClient();
    }
    
    let file = option.file
    const fileName = props.filename;
    
    return ossClient.put(fileName, file).then(result => {
      const fullUrl = base_img.endsWith("/") ? base_img + result.name : base_img + "/" + result.name;
      fileList.value = [{name: props.name, url: fullUrl}];
      emit("uploadSuccess", result.name, props.name);
    }).catch(async (err) => {
      console.log(`Common upload ${file.name} failed === `, err);
      // 如果是凭证错误，尝试重新获取凭证并重试一次
      if (err.code === 'InvalidAccessKeyIdError' || err.status === 403) {
        console.log('凭证可能过期，重新获取凭证并重试...');
        credentials = null;
        ossClient = null;
        credentialPromise = null;
        await ensureOSSClient();
        // 重试上传
        try {
          const result = await ossClient.put(fileName, file);
          const fullUrl = base_img.endsWith("/") ? base_img + result.name : base_img + "/" + result.name;
          fileList.value = [{name: props.name, url: fullUrl}];
          emit("uploadSuccess", result.name, props.name);
        } catch (retryErr) {
          console.error('重试上传失败:', retryErr);
          throw retryErr;
        }
      } else {
        throw err;
      }
    });
  } catch (err) {
    console.error('上传失败:', err);
    throw err;
  }
}

// 获取凭证
async function getCredential() {
  if (credentialPromise) {
    return credentialPromise;
  }
  credentialPromise = VE_API.ali.credential()
    .then(({ data }) => {
      credentials = data;
      return data;
    })
    .catch((err) => {
      credentialPromise = null;
      throw err;
    });
  return credentialPromise;
}

// 初始化 OSS 客户端
async function initOSSClient() {
  if (!credentials) {
    throw new Error('凭证未获取，无法初始化 OSS 客户端');
  }
  const { accessKeyId, accessKeySecret, securityToken } = credentials;
  ossClient = new OSS({
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: securityToken,
    bucket,
    region
  });
}

// 确保 OSS 客户端已初始化
async function ensureOSSClient() {
  if (!credentials) {
    await getCredential();
  }
  if (!ossClient) {
    await initOSSClient();
  }
}

// 组件挂载时预获取凭证
getCredential().catch(err => {
  console.error('预获取 OSS 凭证失败:', err);
});

</script>

<style scoped>

</style>